<div class="d-flex align-items-center hand top"><img class="" (click)="toggleIcon()" [src]="arrowImg" width="14" height="14"></div>